import { render, staticRenderFns } from "./EcosystemNeedsModal.vue?vue&type=template&id=49252ffc&scoped=true"
import script from "./EcosystemNeedsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EcosystemNeedsModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49252ffc",
  null
  
)

export default component.exports